export default __webpack_public_path__ + "static/cni-3-c439d09b239a4581e7c80bfa4bc2f7b5.png";